const About = () => {
  const stats = [
    { value: '100+', label: 'Projects Completed' },
    { value: '80+', label: 'Happy Clients' },
    { value: '10+', label: 'Years Experience' },
    { value: '95%', label: 'Client Satisfaction' },
  ];

  return (
    <section id="about" className="section-padding bg-background">
      <div className="container-padding max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-20 items-center">
          <div>
            <p className="text-eyebrow font-medium text-sm mb-4">About RLX</p>
            <h2 className="heading-lg text-foreground mb-6">
              Your trusted digital partner in Hong Kong
            </h2>
            <div className="space-y-4 text-body">
              <p>
                RLX is a full-service digital agency based in the heart of Tsim Sha Tsui East, Hong Kong.
                We craft digital experiences that stand out — from fast, conversion-focused websites to
                native mobile apps and complete brand identity systems that help businesses grow in today's
                competitive landscape.
              </p>
              <p>
                Our team combines creative vision with technical expertise to deliver solutions that not only
                look stunning but also perform brilliantly. Every website we build is responsive, SEO-ready and
                tuned for Core Web Vitals, so your customers get a smooth experience on any device. From
                early-stage startups to established Hong Kong enterprises, we've helped clients across retail,
                F&B, beauty, fintech and professional services launch products their users love.
              </p>
              <p>
                We believe great digital work is a partnership. We take time to understand your goals, your
                customers and your market, then translate that into a clear plan: discovery, design,
                development, launch and ongoing support. The result is digital experiences that don't just
                look good in a portfolio — they drive real business outcomes.
              </p>
              <p>
                Based in Hong Kong and serving clients across Asia, we're proud to be a long-term digital
                partner for the brands we work with. Whether you need a brand-new website, a custom mobile
                app, or a refreshed visual identity, our team is ready to help you stand out online.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-6 md:gap-8">
            {stats.map((stat, index) => (
              <div
                key={stat.label}
                className="p-8 rounded-2xl bg-card border border-border text-center"
              >
                <div className="text-4xl md:text-5xl font-bold text-primary mb-2">
                  {stat.value}
                </div>
                <p className="text-muted-foreground text-sm md:text-base">
                  {stat.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
